<ngx-spinner [fullScreen]="false"
             type="ball-clip-rotate-multiple"
             bdColor="rgba(51,51,51,0.8)"
             size="medium"
             color="#fff">
</ngx-spinner>
<div fxLayout="row wrap">
  <Teranet-PageTitle [PageTitle]="data?.id > 0 ? 'Edit Holiday Date' : 'Add Holiday Date'"></Teranet-PageTitle>
  <mat-divider></mat-divider>
</div>
<div mat-dialog-content>
  <div fxLayout="column">
    <div class="teranet-padding" fxFlex="100" fxLayout="column">
      <form #holidayDateForm="ngForm"
            (ngSubmit)="onSubmit()"
            [formGroup]="holidayDateFormGroup"
            novalidate>
        <div fxFlex="100">
          <div fxLayout="column" fxLayoutAlign="center stretch">
            <div class="form-group-flex-column">
              <mat-label class="required-field-after">Holiday</mat-label>
              <mat-form-field class="mat-form-field-lg" appearance="outline">
                <mat-select formControlName="holidayId"
                            placeholder="--Please Select--"
                            required>
                  <mat-option *ngFor="let holiday of holidays" [value]="holiday.id">
                    {{ holiday.code }}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="holidayDateFormGroup.get('holidayId').hasError('required')">
                  {{ holidayErrorMessage.HOLIDAY_REQUIRED }}
                </mat-error>
              </mat-form-field>
            </div>
            <Teranet-MonthDayYearPicker [disabled]="false"
                                        [label]="'Holiday Date'"
                                        [error]="holidayDateFormGroup.get('date').errors?.required
                                          ? holidayErrorMessage.DATE_REQUIRED
                                          : ''"
                                        [classCss]="'mat-form-field-lg'"
                                        [required]="true"
                                        formControlName="date"></Teranet-MonthDayYearPicker>
            <div class="form-group-flex-column">
              <mat-label class="required-field-after">Description</mat-label>
              <mat-form-field class="mat-form-field-lg" appearance="outline">
                <input data-lpignore="true"
                       formControlName="description"
                       matInput
                       required />
                <mat-error *ngIf="holidayDateFormGroup.get('description').hasError('required')">
                  {{ holidayErrorMessage.DESCRIPTION_REQUIRED }}
                </mat-error>
              </mat-form-field>
            </div>
          </div>
          <div fxLayout="row wrap" fxLayoutAlign="end">
            <button mat-raised-button class="plain-button" type="button" (click)="onClose()">Cancel</button>
            <button mat-raised-button class="theme-button" type="submit">Save</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
